module.exports = __webpack_public_path__ + "814246bb2bc95390652e2be7e5c5ad5f.woff2";